import { Tabs } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import * as React from 'react';
import { TabsEnum } from 'v3/shared/enums/tabs-emun';
import { StyledTabs } from './styles';
import { ILabTabsProps } from './types';

export default function LabTabs({ tabsData, tabValue, setTabValue }: ILabTabsProps) {
  const handleChange = (event: React.SyntheticEvent, newValue: TabsEnum) => {
    setTabValue(newValue);
  };

  return (
    <StyledTabs>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <Tabs value={tabValue} textColor="inherit" onChange={handleChange} aria-label={tabsData.title}>
          {tabsData.tabs.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
      </Box>
    </StyledTabs>
  );
}
